import { Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { featureDetailLinesForId } from '@/constants/productFeatureConstants'

export interface FeatureDetailLinesProps {
  featureId: string
  isTrial?: boolean
}

export const FeatureDetailLines = ({
  featureId,
  isTrial = false,
}: FeatureDetailLinesProps) => {
  const lines = featureDetailLinesForId(featureId, isTrial)
  if (lines.length === 0) return null

  return (
    <ul className="mt-1 flex list-disc flex-col gap-1 pl-4">
      {lines.map((line) => (
        <li key={line}>
          <Text variant={TypographyStyles.BODY_SM} className="text-neutral-500">
            {line}
          </Text>
        </li>
      ))}
    </ul>
  )
}
